export default __webpack_public_path__ + "static/1940_1950-0cfd1d09f8d7e525dcefa37a5bd3862e.jpg";